'use client';

import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Menu } from '@pickleballinc/react-ui';
import clsx from 'clsx';
import { Range } from 'react-range';

interface SkillRangeProps {
	setSkill: (values: number[]) => void;
	skill: number[];
	filterName?: string;
}

export const SkillRange = ({ setSkill, skill, filterName }: SkillRangeProps) => {
	return (
		<Menu width={160}>
			<Menu.Trigger asChild>
				<Button
					variant="secondary"
					className={clsx(
						'!border-1 !h-[44px] whitespace-nowrap !rounded-lg !border-gray-300 !bg-white !font-normal !text-gray-500 transition-all'
					)}
					suffixIcon={<FontAwesomeIcon icon={faAngleDown} />}
					data-testid="players-singles-skill-button"
				>
					{filterName ? filterName : 'Single Rating'}
				</Button>
			</Menu.Trigger>
			<Menu.List className="animate-fade-in-down w-fit min-w-[200px] rounded-lg border border-gray-300 bg-white p-4 drop-shadow-md">
				<div className="flex w-full flex-col gap-4">
					<div className="text-sm font-semibold text-gray-900">{filterName ? filterName : 'Single Rating'}</div>
					<div className="flex flex-col">
						<div className="mb-12 flex-1 px-2" data-testid="players-singles-skill-range">
							<Range
								step={0.1}
								min={0}
								max={8}
								allowOverlap={false}
								values={skill.length === 1 ? [Number(skill[0]), 8] : skill}
								onChange={(values) => setSkill(values)}
								renderTrack={({ props, children }) => (
									<div {...props} className="h-2 rounded-md bg-darkorange-400">
										{children}
									</div>
								)}
								renderThumb={({ props, value, isDragged }) => {
									const { key, ...restProps } = props;
									return (
										<div key={key} className="focus:outline-none" {...restProps}>
											<span className="absolute left-1/2 top-full mt-1 -translate-x-1/2 px-1 py-0.5">{value.toFixed(1)}</span>
											<div
												className={`size-5 rounded-full shadow-md focus:outline-none
                              ${isDragged ? 'cursor-grabbing' : 'cursor-pointer'}
                              ${isDragged ? 'border-dark-orange-600 bg-darkorange-600' : 'border-gray-100 bg-darkorange-600'}`}
											/>
										</div>
									);
								}}
							/>
						</div>
						{skill[0] !== 0 || skill[1] !== 8 ? (
							<Button
								variant="secondary"
								className="w-full justify-center"
								onClick={() => setSkill([0, 8])}
								data-testid="players-singles-skill-reset"
							>
								Reset
							</Button>
						) : null}
					</div>
				</div>
			</Menu.List>
		</Menu>
	);
};
